import React, {useState} from 'react'
import {Row, Typography, VertContainer} from "@vertem-core/vertice-ds";
import MediaQuery from "react-responsive";
import Lottie from "react-lottie";
import LoadingAnimation from "../../../Assets/animations/loading.json";
import {useSolicitation} from "../Provider";

const SolicitationPresentation = () => {
    const Solicitation = useSolicitation()
    const options = {
        loop: true,
        autoplay: true,
        animationData: LoadingAnimation,
    };

    return (
        <>
            <VertContainer>
                <MediaQuery minWidth={769}>
                    <Row align='middle' justify="space-around" style={{ height: '600px' }}>
                        <div>
                            <Lottie
                                options={options}
                                height={400}
                                width={400}
                                isClickToPauseDisabled
                            />
                            <Typography.Title
                                style={{
                                    textAlign: 'center'
                                }}
                            >
                                { Solicitation.message }
                            </Typography.Title>
                        </div>
                    </Row>
                </MediaQuery>
                <MediaQuery maxWidth={768}>
                    <Row align='middle' justify="space-around" style={{ height: '500px' }}>
                        <div>
                            <Lottie
                                options={options}
                                height={300}
                                width={300}
                                isClickToPauseDisabled
                            />
                            <Typography.Title
                                style={{
                                    textAlign: 'center'
                                }}
                            >
                                { Solicitation.message }
                            </Typography.Title>
                        </div>
                    </Row>
                </MediaQuery>
            </VertContainer>
        </>
    )
}

export default SolicitationPresentation;
